// src/modules/app-views/offers/pages/Init/components/tableColumns/priceColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { DollarOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function priceColumn(buildColumnProps, options = {}) {
  const {
    key = 'price',
    title = 'pricing',
    dataIndex = ['pricing', 'fixedValue'],
    width = 140,
    align = 'right',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps('pricing.fixedValue', columnProps),
    render: (_, r) => {
      const mode = r?.pricing?.mode;
      if (!mode) return '—';

      const fmt = v =>
        new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);

      if (mode === 'fixed' && r?.pricing?.fixedValue != null) {
        return (
          <span>
            <DollarOutlined style={{ marginRight: 4, color: '#52c41a' }} />
            {fmt(r.pricing.fixedValue)}
          </span>
        );
      }

      if (mode === 'range') {
        const min = r?.pricing?.minValue;
        const max = r?.pricing?.maxValue;
        if (min != null && max != null) {
          return `${fmt(min)} — ${fmt(max)}`;
        }
      }

      return translateX(mode);
    },
  };
}

export default priceColumn;
